// extracted by mini-css-extract-plugin
module.exports = {"container":"sZ2pK","box":"wuICo","title":"fh0ts","subtitle":"_3pT2U","button":"_1uV1b"};